import {
  LendLostRequestCollection,
  LendLostRequestCollectionToJSON
} from '@/api'

export interface LendLostRequest {
  id: string
  collections: LendLostRequestCollection[]
  lostType: string
}

export function LendLostRequestToJSON(value: LendLostRequest): any {
  return {
    id: value.id,
    collections: value.collections.map(LendLostRequestCollectionToJSON),
    lost_type: value.lostType
  }
}
